export const BAD_STATUS = 404;
